












export default

	props:
		buttons: Array
		inverted:
			type: Boolean
			default: false

	computed:
		theme: -> 'inverted' if @inverted

